<template>
    <div>
        <section class="breadcrumb-section cart">
            <div class="container">
                <nav aria-label="breadcrumb" v-if="false">
                    <ol class="breadcrumb">
                        <li class="breadcrumb-item">
                            <router-link to="/">Home</router-link>
                        </li>
                        <li class="breadcrumb-item active" aria-current="page">
                            Thankyou
                        </li>
                    </ol>
                </nav>
            </div>
        </section>

        <section class="cart_page pt-0">
            <div class="container">
                <div class="row">
                    <div class="col-md-4"></div>
                    <div class="col-md-4 tahnkyou_center">
                        <div>
                            <h1>Thank you!</h1>
                            <p>
                                Your Payment is done succesufully
                                <router-link
                                    :to="{
                                        name: 'Order_detail',
                                        params: {
                                            id: this.$route.params.order_id
                                        }
                                    }"
                                    >{{
                                        this.$route.params.unique_order_id
                                    }}</router-link
                                >
                                <!-- you will get order id here -->
                            </p>
                        </div>
                        <div
                            class="cart_buttons d-flex flex-wrap mt_28 align-items-center"
                        >
                            <a
                                href="/category/apparel"
                                class="btn btn_primary bg_primary_blue text_white py_18 px_28"
                            >
                                Continue Shopping</a
                            >
                        </div>
                    </div>
                    <div class="col-md-4"></div>
                </div>
            </div>
        </section>
    </div>
</template>

<script>
export default {
    /* eslint-disable */
    name: "Thankyou",
    /* eslint-enable */
    data() {
        return {};
    },
    components: {},
    mounted() {
        this.ifOrderIdNotFound();
    },
    methods: {
        ifOrderIdNotFound() {
            if (this.$route.params.order_id == null) this.$router.push("/");
            console.log(this.$route.params.order_id);
        }
    }
};
</script>
